import styled from "styled-components";

import type { ActivityGroupStatus } from "../components/ActivityDetailsGroup/ActivityDetailsGroup";
import { Colors } from "@smartsuite/types";

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledHeader = styled.div<{ status: ActivityGroupStatus }>`
  position: relative;
  height: 50px;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  margin-bottom: 22px;

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 6px;
    background-color: ${(props) =>
      props.status === "is_success" ? Colors.dwGreen : Colors.dwRed};
    opacity: 0.5;
    z-index: -1;
  }
`;

export const StyledTitle = styled.div`
  display: flex;
  align-items: center;
`;
